/**
 * Quantita' di una taglia a partire da quello che l'utente ha digitato.
 *
 * Le quantita' negative non hanno significato e a valle rompono i calcoli del piano,
 * quindi si riportano a zero. Un `parseInt(x) || 0` non basta: -1 e' truthy e passava
 * indenne, ed e' cosi' che una taglia a -1 e' finita nel piano di un cliente.
 *
 * Campo vuoto, "-" da solo, testo non numerico e valori non finiti valgono zero.
 * I decimali vengono troncati: le taglie sono capi interi.
 */
export const normalizzaQuantitaTaglia = (
  value: string | number | null | undefined,
): number => {
  const numero = typeof value === 'number' ? value : parseInt(String(value ?? ''), 10);
  if (!Number.isFinite(numero) || numero < 0) return 0;
  return Math.trunc(numero);
};
